var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Nord__Icn/40px/Nord",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.756494,32.5668512 L15.756494,20.6278679 L15.8004681,20.6278679 L23.4959454,32.5668512 L27.0138779,32.5668512 L27.0138779,17 L24.243506,17 L24.243506,28.565203 L24.1995319,28.565203 L16.6579642,17 L12.9861221,17 L12.9861221,32.5668512 L15.756494,32.5668512 Z M20,5.72905273 L25.4852814,11.2143341 L20,16.6996155 L14.5147186,11.2143341 L20,5.72905273 Z M20,8.55747986 L15.9289322,12.6285477 L20,16.6996155 L24.0710678,12.6285477 L20,8.55747986 Z",
    id: ".._.._src_svg_Icn_40px_Nord__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNord);
export default __webpack_public_path__ + "static/media/Nord.150c3282654e035b1cbc620f4efb9b80.svg";
export { ForwardRef as ReactComponent };